import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#0000E7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M8 28H5.333C4.533 28 4 27.467 4 26.667v-8c0-.8.533-1.334 1.333-1.334H8c.8 0 1.333.534 1.333 1.334v8C9.333 27.467 8.8 28 8 28"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#0000E7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M17.333 22.667H20.4c.533 0 1.2-.134 1.6-.534l3.2-2.4c.8-.666 1.867-.533 2.667.134.8.8.8 2 0 2.8l-2.8 2.8c-.8.8-1.734 1.2-2.667 1.466l-3.867.8q-1.2.201-2.4 0l-3.6-.933c-.266-.133-.8-.133-1.2-.133h-2"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#0000E7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M17.333 22.667h2c1.067 0 2-.934 2-2v-.4c0-.934-.666-1.734-1.466-2l-3.067-.8c-.533-.134-1.067-.134-1.6-.134-1.2 0-2.4.4-3.467 1.067l-2.4 1.6M22.267 6c.4-.667 1.066-.8 1.6-.533.133.133.4.266.4.4l.933 1.6c.133.266.4.533.533.666l1.6.934c.667.266.8.933.534 1.466-.134.134-.267.4-.534.534l-1.6.933c-.133 0-.4.267-.533.4l-.933 1.6c-.267.533-1.067.8-1.6.4-.134-.133-.4-.267-.4-.4l-.934-1.6c0-.133-.266-.4-.4-.4l-1.6-.933c-.666-.4-.8-1.067-.533-1.6.133-.134.267-.4.533-.534l1.6-.933c.134 0 .4-.267.4-.4zM10.533 4.4c.267-.4.8-.533 1.2-.267.134 0 .267.134.267.267l.667 1.2c.133.133.133.267.266.267l1.2.666c.4.267.534.667.267 1.2.133.134 0 .267-.133.267l-1.2.667-.4.4-.667 1.2c-.133.4-.667.533-1.067.266-.133 0-.266-.133-.4-.266L10 9.067l-.4-.4L8.4 8c-.4-.133-.533-.667-.267-1.067 0-.133.134-.266.267-.4l1.2-.666c.133-.134.267-.134.267-.267z"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }